import ReactMarkdownEditor, {
  defaultCommands,
} from "@uiw/react-markdown-editor";
import React, { FC } from "react";

interface MarkdownEditorProps {
  value?: string;
  handleChange: (value?: string) => void;
}

const MARKDOWN_TOOLS = [
  defaultCommands.undo,
  defaultCommands.redo,
  defaultCommands.bold,
  defaultCommands.italic,
  defaultCommands.header,
  // defaultCommands.strike,
  defaultCommands.underline,
  defaultCommands.quote,
  defaultCommands.olist,
  defaultCommands.ulist,
  // defaultCommands.todo,
  defaultCommands.link,
  defaultCommands.image,
  //defaultCommands.code,
  //defaultCommands.codeBlock,
];
const MARKDOWN_MODE = [defaultCommands.preview, defaultCommands.fullscreen];
const MarkdownEditor: FC<MarkdownEditorProps> = ({ handleChange, value }) => {
  return (
    <>
      <ReactMarkdownEditor
        className="markdown-editor-container"
        value={value}
        onChange={handleChange}
        toolbars={MARKDOWN_TOOLS}
        toolbarsMode={MARKDOWN_MODE}
      />
    </>
  );
};

export { MarkdownEditor, MarkdownEditorProps };
